<template>
  <div>
    <kst-output print-mode field="TotalBruto" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="TotalDisc" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="TotalRetur" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="Total" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../OmzetCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>